import React, {Component} from 'react';
import {BrowserRouter, Switch, Route} from 'react-router-dom';
import './App.css';

// Import Components for Routes
import BeltList from './components/About/Belts';
import Foundation from './components/About/Foundation';
import History from './components/About/History';
import Style from './components/About/Style';
import ClubList from './components/Info/Clubs';
import Contact from './components/Contact/Contact';
import Login from './components/Login/Login';

class App extends Component {
	render() {
		return (
			<BrowserRouter>
				<Switch>
					<Route exact path="/" component={ClubList} />
					<Route exact path="/about/belts" component={BeltList} />
					<Route exact path="/about/foundation" component={Foundation} />
					<Route exact path="/about/history" component={History} />
					<Route exact path="/about/style" component={Style} />
					<Route exact path="/info/clubs" component={ClubList} />
					<Route exact path="/contact" component={Contact} />
					<Route exact path="/login" component={Login} />
				</Switch>
			</BrowserRouter>
		);
	}
}

export default App;




// WEBPACK FOOTER //
// ./src/App.js